module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Weight","gram":"gram","kilogram":"kilogram","ounce":"ounce","pound":"pound","save":"Save"},"de":{"label":"Gewicht","gram":"gramm","kilogram":"kilogramm","ounce":"unzen","pound":"pfund","save":"Speichern"}}')
  delete Component.options._Ctor
}
